import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { colors } from '@offerzen/pinata-shame'
import CaretDownIcon from '@offerzen/zenicon/CaretDownIcon'

import AccessibleIcon from '../AccessibleIcon'

import styles from './styles'

class NavDropdown extends Component {
  static propTypes = {
    label: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    className: PropTypes.string,
  }

  state = {
    open: false,
  }

  render() {
    const { open } = this.state
    const { className, label, children } = this.props

    return (
      <div className={cx(styles.wrapper, className)}>
        <a role="presentation" className={cx(styles.trigger, open && styles.triggerOpen)} onClick={() => this.setState({ open: !open })}>
          <span>{label}</span>
          <div className={styles.icon}>
            <AccessibleIcon icon={CaretDownIcon} size={16} colors={colors.white} />
          </div>
        </a>

        <If condition={open}>
          <ul className={styles.body}>{children}</ul>
          <div className={styles.overlay} onClick={() => this.setState({ open: false })} />
        </If>
      </div>
    )
  }
}

export default NavDropdown
